module.exports = __webpack_public_path__ + "img/bankett.3bac4a36.jpg";